import React from 'react'

import {
  Card,
  ErrorBoundary
} from 'components'
import { useGet, usePersistForm } from 'hooks'
import { useForm, FormProvider } from 'react-hook-form'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGraduacaoMultasGetAllParams, IGraduacaoMultasGetAllResponse } from 'services/GST/GraduacaoMultas'
import { SPACING, FUNCTIONS } from 'utils'

import GraduacaoDeMultasTable from './components/GraduacaoDeMultasTable'
import SearchFields from './components/SearchFields'
import { IForm } from './types'

const Search: React.FC = () => {
  const methods = useForm<IForm>()

  usePersistForm('register-fine-graduation-form', {
    setValue: methods.setValue,
    watch: methods.watch
  })

  const {
    data,
    refresh: refreshTable,
    isFirstGet,
    page,
    rowsPerPage,
    handleChangeRowsPerPage,
    handleChangePage
  } = useGet<IGraduacaoMultasGetAllParams, IPaginatedEntityGST<IGraduacaoMultasGetAllResponse[]>>({
    api: 'Gst',
    isPaginated: true,
    params: {
      ...FUNCTIONS.filterObject(methods.getValues(), Boolean)
    },
    url: 'Gradacao/Filter',
    formPersist: {
      getValues: methods.getValues
    }
  })

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <SearchFields
          refreshTable={refreshTable}
          isFirstGet={isFirstGet}
        />
        <ErrorBoundary>
          <GraduacaoDeMultasTable
            data={data}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
          />
        </ErrorBoundary>
      </Card>
    </FormProvider>
  )
}

export default Search
